import Request from '../utils/request'

export function getDoctorByNameApi (params) {
  return Request({
    url: '/follow/doctor/getByName',
    method: 'get',
    params
  })
}
